import {
  a as t,
  b as o,
  c as r
} from "./chunk-BVHSVHOK.js";

// src/browser.ts
function p() {
  return o();
}
function a() {
  return r();
}
var s = r();
export {
  a as createColors,
  s as default,
  t as getDefaultColors,
  p as isSupported
};
